import http from './http';

const USE_MOCK = process.env.REACT_APP_ENABLE_MOCK_AUTH !== 'false'; // true por defecto

/**
 * Mock Login - Para desarrollo sin backend
 */
const mockLogin = async (credentials) => {
  await new Promise(resolve => setTimeout(resolve, 400));
  
  if (!credentials.email || !credentials.password) {
    throw new Error('Email y contraseña son requeridos');
  }

  if (credentials.password === 'error') {
    throw new Error('Credenciales inválidas');
  }
  
  // Retornar datos mock
  return {
    token: `mock-token-${Date.now()}`,
    user: {
      id: '123',
      email: credentials.email,
      name: 'Usuario Demo',
      role: 'admin',
      permissions: ['read', 'write', 'delete'],
    },
  };
};

/**
 * Real Login - Llamada a API
 */
const realLogin = async (credentials) => {
  const response = await http.post('/auth/login', credentials);

  return response.data;
};

/**
 * Login (Mock o Real según configuración)
 */
export const login = async (credentials) => {
  if (USE_MOCK) {
    console.info('🧪 Using MOCK login');
    return mockLogin(credentials);
  }
  
  return realLogin(credentials);
};

/**
 * Logout
 */
export const logout = async () => {
  try { 
    await http.post('/auth/logout');
  } finally {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
  }
};

/**
 * Verificar si el usuario está autenticado
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('accessToken');
  return !!token;
};

/**
 * Obtener usuario actual del localStorage
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return null;
  }
};

/**
 * Refresh Token (placeholder)
 */
export const refreshToken = async () => {
  const response = await http.post('/auth/refresh');
  localStorage.setItem('accessToken', response.data.accessToken);
  return response.data.accessToken;
  
};

export const setPasswordWithToken = async ({ token, password }) => {
  const response = await http.post('/auth/set-password-with-token', {
    token,
    password,
  });

  return response.data;
}
const authService = {
  login,
  logout,
  isAuthenticated,
  getCurrentUser,
  refreshToken,
  setPasswordWithToken
};

export default authService;

